import styled from "styled-components";
import { theme } from "../../theme";

export const StyledCheckboxContainer = styled.div<{
  disabled?: boolean;
  readonly?: boolean;
  message?: string;
}>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  svg {
    height: 25px;
    width: 25px;
    margin-right: 16px;
  }
  span {
    display: inline-block;
    position: relative;
    width: 60%;
  }
  small.info {
    display: inline-flex;
    border: 2px solid ${theme.textColor.secondaryBlack};
    height: 14px;
    width: 14px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    cursor: pointer;
    font-size: 10px;
    top: -1px;
    position: relative;
    font-weight: 700;
    color: ${theme.textColor.secondaryBlack};
  }

  span::after {
    content: "${({ message }) => `${message}`}";
    position: absolute;
    background-color: ${theme.backgroundColor.primaryBlack};
    width: fit-content;
    display: ${({ message }) => (message ? "inline-block" : "none")};
    padding: 5px;
    opacity: 0.8;
    color: ${theme.textColor.primaryWhite};
    margin-left: 10px;
    font-size: 11px;
    align-self: flex-end;
  }
`;
